


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class FormFieldContainerFacturacion extends Vue {
  @Prop({}) titulo: string;

  imprimir() {}
}
